import { Text as ChakraText } from "@chakra-ui/layout";

export const Text = ChakraText;
